import Icon from 'veui/components/Icon'
import { IconVideoAdd } from 'dls-icons-vue'

Icon.register('video-add', IconVideoAdd)
